module.exports = __webpack_public_path__ + "img/secondfeatureicon.6df4d51b.webp";